import script from "./TagSidebarItems.vue?vue&type=script&setup=true&lang=ts"
export * from "./TagSidebarItems.vue?vue&type=script&setup=true&lang=ts"

import "./TagSidebarItems.vue?vue&type=style&index=0&id=49114b99&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49114b99"]])

export default __exports__